import { render, staticRenderFns } from "./booked-bags.vue?vue&type=template&id=16f51a74&scoped=true"
import script from "./booked-bags.vue?vue&type=script&lang=js"
export * from "./booked-bags.vue?vue&type=script&lang=js"
import style0 from "./booked-bags.vue?vue&type=style&index=0&id=16f51a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f51a74",
  null
  
)

export default component.exports